import { get, post } from "../helpers/api_helper"

// Fleet (vehicle master). Owner = a company flagged is_vehicle_owner; each vehicle gets an
// auto-created Fixed-Asset ledger under the shared "Motor Vehicles" group in the owner's books.
export const getVehicles = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  ).toString()
  return get(`fleet/list${qs ? `?${qs}` : ""}`)
}
export const getVehicleOwners = () => get("fleet/owners")
export const getFleetDashboard = () => get("fleet/dashboard")
export const getFleetFuelExpenseSummary = (params = {}) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString()
  return get(`fleet/fuel-expense-summary${qs ? `?${qs}` : ""}`)
}
export const getFleetTransportationReport = (params = {}) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString()
  return get(`fleet/transportation-report${qs ? `?${qs}` : ""}`)
}
export const getFleetMonthlyExpensesReport = (params = {}) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString()
  return get(`fleet/monthly-expenses-report${qs ? `?${qs}` : ""}`)
}
export const getFleetAverageCostingReport = (params = {}) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString()
  return get(`fleet/average-costing-report${qs ? `?${qs}` : ""}`)
}
export const saveFleetCostingInputs = (year, invoiced, employees) => post("fleet/costing-inputs", { year, invoiced, employees })
// Fleet expense-account settings (Developer → Fleet Accounts) + the vehicle-form ledger picker
export const getFleetExpenseSettings = () => get("fleet/expense-settings")
export const saveFleetExpenseSettings = group_ids => post("fleet/expense-settings", { group_ids })
export const getFleetExpenseLedgers = companyId =>
  get(`fleet/expense-ledgers${companyId ? `?company_id=${companyId}` : ""}`)
// per-company cost-ledger matrix (Developer → Fleet Accounts, Section 2)
export const getFleetCostLedgerSettings = () => get("fleet/cost-ledger-settings")
// payload: { mapping, vat_mode, vat_mapping }
export const saveFleetCostLedgerSettings = payload => post("fleet/cost-ledger-settings", payload)
// voucher-entry vehicle picker: which ledger groups trigger it + the vehicle list
export const getFleetVoucherContext = () => get("fleet/voucher-context")
// fuel-entry "Pay from" picker: the common (shared) bank + cash ledgers
export const getFleetPaymentLedgers = () => get("fleet/payment-ledgers")
// camps (staging sources for daily allotment) — reused from the Camp module
export const getCampList = () => get("camp/list")

// daily vehicle allotment
export const getFleetAllotments = params => {
  const qs = new URLSearchParams(
    Object.entries(params || {}).filter(([, v]) => v !== "" && v != null)
  ).toString()
  return get(`fleet/allotments${qs ? `?${qs}` : ""}`)
}
// a site leg is booked against a project; its assigned members are the pool that can board it
export const getAllotmentProjects = () => get("fleet/allotment/projects")
export const getAllotmentProjectMembers = params => {
  const qs = new URLSearchParams(
    Object.entries(params || {}).filter(([, v]) => v !== "" && v != null)
  ).toString()
  return get(`fleet/allotment/project-members${qs ? `?${qs}` : ""}`)
}
export const saveFleetAllotment = data => post("fleet/allotment/save", data)
export const removeFleetAllotment = id => post(`fleet/allotment/remove/${id}`, {})

// fuel consumption
export const getFleetFuelReport = params => {
  const qs = new URLSearchParams(
    Object.entries(params || {}).filter(([, v]) => v !== "" && v != null)
  ).toString()
  return get(`fleet/fuel-report${qs ? `?${qs}` : ""}`)
}
export const saveFleetFuelLog = data => post("fleet/fuel/save", data)
export const removeFleetFuelLog = id => post(`fleet/fuel/remove/${id}`, {})
// post the payment voucher for an existing fuel entry (2nd way — from the list)
export const postFleetFuelVoucher = (id, payment_ledger_id) => post(`fleet/fuel/${id}/post-voucher`, { payment_ledger_id })
export const postAllFleetFuelVouchers = (payment_ledger_id, month) => post("fleet/fuel/post-all", { payment_ledger_id, month })
// maintenance / service entries (mirrors fuel)
export const getFleetMaintenance = (params = {}) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString()
  return get(`fleet/maintenance${qs ? `?${qs}` : ""}`)
}
export const saveFleetMaintenanceLog = data => post("fleet/maintenance/save", data)
export const removeFleetMaintenanceLog = id => post(`fleet/maintenance/remove/${id}`, {})
export const postFleetMaintenanceVoucher = (id, payment_ledger_id) => post(`fleet/maintenance/${id}/post-voucher`, { payment_ledger_id })

export const getVehicle = id => get(`fleet/${id}`)
export const createVehicle = data => post("fleet/create", data)
export const updateVehicle = (id, data) => post(`fleet/edit/${id}`, data)
export const removeVehicle = id => post(`fleet/remove/${id}`, {})
